import queryString from "query-string"
import { call, put, select } from "redux-saga/effects"

import {
  panelAttempted,
  panelComplete,
  panelIncomplete,
  panelOpen,
} from "areas/checkout/store/actions"

function validateSchema(schema, values) {
  return Promise.resolve(
    schema.validate(values, {
      abortEarly: false,
    })
  )
}
export default function* validatePanels(action) {
  const state = yield select()

  const location = state.router.location
  const query = queryString.parse(location.search)
  let panels = []
  if (action.data && action.data.panels) {
    panels = action.data.panels
  } else if (state.checkout.panels) {
    panels = state.checkout.panels
  }

  try {
    const values = state.checkout.form.values

    yield call(validateSchema, state.checkout.form.schema, values)

    for (const [index, panel] of panels.entries()) {
      let actionType = "close"
      if (query.panel === panel.name) {
        actionType = "open"
      }
      yield put(panelComplete(index, actionType))

      if (panel.name === "payment_methods") {
        yield put(panelOpen(index))
      }
    }
  } catch (validateErrors) {
    const formErrors = validateErrors?.inner?.map((err) => err.path) || []

    for (const [index, panel] of panels.entries()) {
      // checks if panel has error
      const panelInvalid = panel.fields.some((field) => {
        const fieldError = formErrors.includes(field)
        return fieldError
      })

      if (panelInvalid) {
        // If invalid, open panel.
        if (index !== 0) {
          yield put(panelAttempted(index))
        }
        yield put(panelIncomplete(index))
        break
      } else if (
        action?.data?.is_new_amazon &&
        panel.name === "payment_methods"
      ) {
        yield put(panelAttempted(index))
        yield put(panelIncomplete(index))
      } else {
        let actionType = "close"
        if (query.panel === panel.name) {
          actionType = "open"
        }
        yield put(panelComplete(index, actionType))
      }
    }
  }
}
